// extracted by mini-css-extract-plugin
export default {"timelineItem":"timeline_timelineItem__3Z2Ks","selector":"timeline_selector__tpzng"};